import { BackButton, RoundedFilledButton } from '@/components/buttons/Buttons';
import { useNavigate } from 'react-router-dom';
import { Chip } from 'primereact/chip';
import { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import styles from './billing-method-screen.module.css';
import { useQuery } from '@tanstack/react-query';
import { BillingApi, BillingInfoDto } from '../billing.api';
import BillingInfoForm, { BillingFormLayoutType, BillingInfoFormRef, BillingInfoFormType } from '../components/forms/BillingInfoForm';
import { showTypedModal } from '@/common/common_utils';
import RequestBillingInfoFormModal from '../billing-information/RequestBillingInfoFormModal';
import { TextHeadlineExtraExtraLarge2, TextLabelLarge2 } from '@/components/text/Texts';
import { cn } from '@/components/ui/cn';
import { useAuthenticationStore } from '@/store';
import { X4bUserRoleEnum } from '@/constants/roles';

export default function BillingTypeScreen() {
	const navigate = useNavigate();
	const isManager = useAuthenticationStore((state) => state.hasRoles)([X4bUserRoleEnum.Manager]);

	const billingInfoQ = useQuery({
		queryKey: ['BillingTypeScreen.billingInfo'],
		queryFn: BillingApi.getBillingInfo,
		initialData: {} as BillingInfoDto
	});

	const formName = "billing-info";
	const formRef = useRef<BillingInfoFormRef>(null);

	const form = useForm<BillingInfoFormType>();

	useEffect(() => {
		if (billingInfoQ.data) {
			form.reset(billingInfoQ.data);
		}
	}, [billingInfoQ.data, form]);

	return (
		<div className="pb-[63px]">
			<BackButton
				id="billing-method-back"
				label="Back"
				withIcon
				onClick={() => navigate(-1)}
			/>

			<TextHeadlineExtraExtraLarge2 className="mt-5 mb-6 text-primary" text="Billing Method" />
			<TextLabelLarge2 className="mb-4 text-primary font-semibold" text="Billing Type" />
			<Chip label="Prepaid" className={styles.billingTypeChip} />

			<div className="w-full h-[1px] my-6 bg-surfaceContainerHighest" />

			<TextLabelLarge2 className="mb-4 text-primary font-semibold" text="Billing Info" />
			<BillingInfoForm
				ref={formRef}
				formName={formName}
				initialData={billingInfoQ.data}
				onSubmit={() => { }}
				layoutType={BillingFormLayoutType.BillingView}
			/>
			{isManager && (
				<RoundedFilledButton
					id="deactivate-account"
					label="Update"
					onClick={async () => await showTypedModal(RequestBillingInfoFormModal, {})}
					className={cn(styles.updateButton, 'mt-9')}
				/>)}

		</div>
	);
}
